const removeEmptyObjects = (obj) => {
    if (Object.keys(obj).length === 0) {
        return obj;
    }
    for (let key in obj) {
        if (obj.hasOwnProperty(key) && typeof obj[key] === "object" && !Array.isArray(obj[key])) {
            obj[key] = removeEmptyObjects(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
                delete obj[key];
            }
        }
    }
    return obj;
};

export default removeEmptyObjects;
